import {
    BEGIN_LOAD_REPORTS_FOR_USER,
    END_LOAD_REPORTS_FOR_USER_SUCCESS,
    END_LOAD_REPORTS_FOR_USER_ERROR,
    BEGIN_LOAD_EMBED_INFO,
    END_LOAD_EMBED_INFO_SUCCESS,
    END_LOAD_EMBED_INFO_ERROR,
    CLEAR_EMBED_INFO
} from "./types";
import { AppDispatch } from "../store";
import * as Api from "./api";


export const loadEmbedInfoForReport = (workspaceId : string, reportId: string) => async (dispatch: AppDispatch) => {
    dispatch({ type: BEGIN_LOAD_EMBED_INFO });
    try {
        const embedPbiInfo = await Api.getEmbedInfoForReport(workspaceId, reportId);
        dispatch({ type: END_LOAD_EMBED_INFO_SUCCESS, embedPbiInfo });
    } catch (error) {
        dispatch({ type: END_LOAD_EMBED_INFO_ERROR, error });
    }
};

export const loadReportsforUsers = () => async (dispatch: AppDispatch) => {
    dispatch({ type: BEGIN_LOAD_REPORTS_FOR_USER });
    try {
        const userReports = await Api.getReportsForUsers();
        dispatch({ type: END_LOAD_REPORTS_FOR_USER_SUCCESS, userReports });
    } catch (error) {
        dispatch({ type : END_LOAD_REPORTS_FOR_USER_ERROR, error });
    }
}

export const clearEmbedInfo = () => ({ type: CLEAR_EMBED_INFO });
